module.exports = __webpack_public_path__ + "static/netflixGif-a2299abfada0bff8b2c4728779d36268.gif";